// giztix-web-maps key (giztix-a6af7) — restricted to Maps JavaScript API + *.giztix.com referrers
export default 'AIzaSyDDkXVolvj3f-1EvOvjf6_62ENP2aFMEug';
